module.exports = __webpack_public_path__ + "static/img/ldt2.b693ac1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/ldt/ldt2.png
// module id = +J47
// module chunks = 0